import React, { FC } from 'react';
import { Price } from '@common/components/Price';
import { useTranslations } from '@lang';
import { InfoBox, CloseButton } from './MinimumNight.styles';
import { InfoMessage } from '../Messages.types';

export const MinimumNight: FC<InfoMessage> = ({
  currentSelectedDate,
  showMessage,
  setShowMessage,
}) => {
  const { t } = useTranslations();
  return showMessage && currentSelectedDate && currentSelectedDate?.minimumStay > 1 ? (
    <InfoBox>
      <Price price={currentSelectedDate.price} /> |{currentSelectedDate.minimumStay}-
      {t('rooms.minimumStay')}
      <CloseButton onClick={() => setShowMessage(false)}>Close</CloseButton>
    </InfoBox>
  ) : null;
};
